import { getGeneralInfo } from '@api/store/account/actions';
import { AccessLevel } from '@dev/ee-api/ee-api-models';
import { call, fork, put, select, takeLeading } from 'redux-saga/effects';
import { paymentsProvidersGet } from '../services/ElasticApi';

import { UpdateProviderList, PaymentsError } from '../store/payments/actions';
import * as Types from '../store/payments/types';

import { errorToast } from './commonGenerators/errorToast';

const { ActionTypes } = Types;

function* fetchProvidersList(): any {
    const { AccountAccessLevel } = yield select(getGeneralInfo);
    if (!AccountAccessLevel?.includes(AccessLevel.ViewBilling)) {
        put(UpdateProviderList([]));
        return;
    }
    try {
        const providersList = yield call(paymentsProvidersGet);
        yield put(UpdateProviderList(providersList));
    } catch (e) {
        yield put(PaymentsError());
        yield call(errorToast, e);
    }
}

function* fetchProvidersListWatcher(): any {
    yield takeLeading(ActionTypes.LOAD_PROVIDER_LIST, fetchProvidersList);
}

const paymentsSagas = [fork(fetchProvidersListWatcher)];

export default paymentsSagas;
